import {Component, inject} from '@angular/core';
import {firstValueFrom} from "rxjs";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {ButtonComponent} from "../button/button.component";

@Component({
    selector: 'app-logout-dialog',
    imports: [
        TranslateModule,
        ButtonComponent
    ],
    template: `
    <div class="flex flex-col p-6 md:p-14 gap-6 md:gap-8">
      <img class="mx-auto w-[8rem] md:w-[13rem]" src="/images/logos/logo.svg">
      <div>
        <h1 class="text-2xl text-center font-medium">{{ 'logout' | translate }}</h1>
        <p class="text-center text-[#12121280] text-xs md:text-lg font-medium">{{ 'logout_text' | translate }}</p>
      </div>
      <div class="w-[300px] mx-auto grid grid-cols-2 gap-4">
        <button class="settings-button flex justify-center gap-1" (click)="logout()"><img class="w-4 md:w-5" src="/images/icons/checkmark-black.svg">{{ 'yes' | translate }}</button>
        <button class="settings-button flex justify-center gap-1" (click)="closeDialog()"><img class="w-4 md:w-5" src="/images/icons/close-black.svg">{{ 'no' | translate }}</button>
      </div>
    </div>
  `,
    styles: ``
})
export class LogoutDialogComponent {
  #dialogRef = inject(MatDialogRef);

  closeDialog(): void {
    this.#dialogRef.close();
  }

  logout() {
    this.#dialogRef.close('logout');
  }
}

export async function openLogoutDialog(dialog: MatDialog) {
  const config = new MatDialogConfig();
  config.disableClose = true;
  config.autoFocus = true;
  config.width = '420px';

  const close$ = dialog.open(LogoutDialogComponent, config).afterClosed();

  return firstValueFrom(close$);
}
